import { isNativePlatform } from '@/utils/capacitor';
import { isAppDeepLinkHost } from '@/utils/appDeepLink';

export const ANDROID_APP_PACKAGE = 'com.sporto.bookingmabar';
export const ANDROID_APP_HANDOFF_PARAM = 'appHandoff';

const SESSION_KEY = 'sporto_android_app_handoff';

export function shouldHandoffAndroidApp(
  url: string,
  userAgent: string,
  isNative: boolean
): boolean {
  if (isNative) return false;
  if (!/Android/i.test(userAgent)) return false;
  if (userAgent.includes('SportoMobileApp')) return false;

  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return false;
  }
  if (parsed.searchParams.get(ANDROID_APP_HANDOFF_PARAM) === '0') return false;

  return isAppDeepLinkHost(parsed.hostname);
}

export function buildAndroidAppIntentUrl(url: string): string {
  const parsed = new URL(url);
  parsed.searchParams.delete(ANDROID_APP_HANDOFF_PARAM);
  const fallback = new URL(parsed.href);
  fallback.searchParams.set(ANDROID_APP_HANDOFF_PARAM, '0');
  const hostAndPath = `${parsed.host}${parsed.pathname}${parsed.search}`;
  return (
    `intent://${hostAndPath}#Intent;` +
    `scheme=https;` +
    `package=${ANDROID_APP_PACKAGE};` +
    `S.browser_fallback_url=${encodeURIComponent(fallback.href)};` +
    `end`
  );
}

/** WhatsApp/Chrome Android often pakai Custom Tabs, yang melewati App Links. Intent eksplisit membuka app. */
export function tryAndroidAppHandoff(): void {
  if (typeof window === 'undefined') return;
  const url = window.location.href;
  if (!shouldHandoffAndroidApp(url, navigator.userAgent, isNativePlatform())) return;

  try {
    if (sessionStorage.getItem(SESSION_KEY) === url) return;
    sessionStorage.setItem(SESSION_KEY, url);
  } catch {
    // private mode
  }

  window.location.assign(buildAndroidAppIntentUrl(url));
}
